import * as ProductCardComponents from './ProductCard';
import * as ProductCardSkeletonComponents from './ProductCardSkeleton';
export const ProductCard = {
    ...ProductCardComponents,
    ...ProductCardSkeletonComponents,
};
//# sourceMappingURL=index.js.map